import Vue from 'vue'
import VeeValidate from 'vee-validate'

// var VueValidationEs = require('vee-validate/dist/locale/es')
var VueValidationEn = require('vee-validate/dist/locale/en')


Vue.use(VeeValidate, {
	inject: true,
	fieldsBagName: 'veeFields',
	errorBagName: 'verrors',
	locale: 'en',
	dictionary: {en: VueValidationEn}
})

//https://gist.github.com/RobertGlynWilliams/f31b55160af9df92a970ac5500a16469
Vue.prototype.$setErrorsFromResponse = function(errorResponse) {

//console.log("0");
    // only allow this function to be run if the validator exists
    if(!this.hasOwnProperty('$validator')) {
        return;
    }


//console.log("1");
    // clear errors
    this.$validator.errors.clear();

    // check if errors exist
    if(!errorResponse.hasOwnProperty('errors')) {
        return;
    }
    let errorFields = Object.keys(errorResponse.errors);

    // insert laravel errors
    errorFields.map(field => {
        let errorString = errorResponse.errors[field].join(', ');
        // this.$validator.errors.add(field, errorString);
				// this.$validator.errors.add({
				// 	field: field,
				// 	msg: errorString
				// });
				addErrorToChildComponents(this,field,errorString);
//console.log(errorString);
    });
};

function addErrorToChildComponents(vm,field,errorString) {
    if(vm && vm.$validator && vm.$validator.errors){
        const inputfield = vm.$validator.fields.find({ name: field });
        if(inputfield){
            vm.$validator.errors.add({
                field,
                msg:errorString
            });
            return;
        }
    }
    if(vm.$children){
        vm.$children.map(async ($cvm) => {
            addErrorToChildComponents($cvm,field,errorString);
        });
    }
    return;
}
